
// // import React, { useState } from 'react';
// // import { toast } from 'react-toastify';
// // import { useNavigate, Link } from 'react-router-dom';
// // import axios from 'axios';

// // function Login() {
// //   const [credentials, setCredentials] = useState({ username: '', password: '' });
// //   const [isLoading, setIsLoading] = useState(false);
// //   const navigate = useNavigate();

// //   const baseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:5000';

// //   const handleInputChange = (e) => {
// //     const { name, value } = e.target;
// //     setCredentials({ ...credentials, [name]: value });
// //   };
  
// //   const login = async (e) => {
// //     e.preventDefault();
// //     setIsLoading(true);
    
// //     try {
// //       const response = await axios.post(`${baseUrl}/api/users/login`, credentials, { 
// //         withCredentials: true 
// //       });

// //       if (response.status === 200 && response.data.success) {
// //         const { user, sessionId, isReused } = response.data;
// //         const { tenantid, id: ownerid, username } = user;

// //         // ✅ Store session information in localStorage
// //         localStorage.setItem('authToken', response.data.token || '');
// //         localStorage.setItem('sessionId', sessionId); // ⭐ Store session ID
// //         localStorage.setItem('tenantid', tenantid);
// //         localStorage.setItem('ownerid', ownerid);
// //         localStorage.setItem('username', username);
// //         localStorage.setItem('role', user.role || 'operator');
        
// //         // Store user object for easy access
// //         try {
// //           localStorage.setItem('me', JSON.stringify({ id: user.id, tenantId: user.tenantid }));
// //           window.__ME__ = { id: user.id, tenantId: user.tenantid };
// //         } catch {}
        
// //         if (user) {
// //           localStorage.setItem('user', JSON.stringify(user));
// //         }

// //         // 📌 Show appropriate success message based on session reuse
// //         if (isReused) {
// //           console.log('♻️  Session reused - user was previously logged in');
// //           // Optional: Show a subtle message that they're continuing their previous session
// //           // toast.info('Welcome back! Continuing your previous session.', { autoClose: 2000 });
// //         } else {
// //           console.log('✨ New session created');
// //           // toast.success('Login successful!');
// //         }

// //         navigate(`/${tenantid}/dashboard`);
// //       } else {
// //         toast.error(response.data.message || 'Unexpected error.');
// //       }
// //     } catch (error) {
// //       // Handle specific error cases
// //       if (error.response?.status === 401) {
// //         toast.error('Invalid username or password.');
// //       } else if (error.response?.status === 403) {
// //         // ⭐ Handle user limit reached error
// //         const errorData = error.response.data;
// //         toast.error(
// //           errorData.message || 'Maximum concurrent users reached. Please try again later.',
// //           { autoClose: 8000 }
// //         );
        
// //         // Optionally show details in console
// //         if (errorData.details) {
// //           console.log('User limit details:', errorData.details);
// //         }
// //       } else {
// //         console.error('Login error:', error);
// //         toast.error('Failed to login. Please try again.');
// //       }
// //     } finally {
// //       setIsLoading(false);
// //     }
// //   };

// //   const handleOwner = () => navigate(`/ownerAdd`);

// //   return (
// //     <div className="col=md-4">
// //       <div className="card">
// //         <div className="card-body">
// //           <h4 className="hdr hdr--primary hdr--lg">Login Here</h4>
// //           <form onSubmit={login}>
// //             <div className="form-group">
// //               <label htmlFor="username">Username</label>
// //               <input
// //                 className="textInput"
// //                 type="text"
// //                 name="username"
// //                 value={credentials.username}
// //                 onChange={handleInputChange}
// //                 placeholder="Enter your Username"
// //                 required
// //                 disabled={isLoading}
// //               />
// //             </div>
// //             <div className="form-group">
// //               <label htmlFor="password">Password</label>
// //               <input
// //                 className="textInput"
// //                 type="password"
// //                 name="password"
// //                 autoComplete="current-password"
// //                 value={credentials.password}
// //                 onChange={handleInputChange}
// //                 placeholder="Enter your Password"
// //                 required
// //                 disabled={isLoading}
// //               />
// //             </div>

// //             {/* Forgot password link */}
// //             <div className="mt-2">
// //               <Link to="/reset-password" className="text-sm text-blue-600 hover:underline">
// //                 Forgot password?
// //               </Link>
// //             </div>

// //             <button 
// //               className="btn btn-primary" 
// //               type="submit"
// //               disabled={isLoading}
// //             >
// //               {isLoading ? 'Logging in...' : 'Login'}
// //             </button>
// //             <button 
// //               onClick={handleOwner} 
// //               className="btn btn-primary" 
// //               type="button"
// //               disabled={isLoading}
// //             >
// //               Create Account
// //             </button>
// //           </form>
// //         </div>
// //       </div>

// //       {/* Footer with Terms of Service and Privacy Policy links */}
// //       <footer style={{
// //         borderTop: '1px solid #e0e0e0',
// //         padding: '20px',
// //         textAlign: 'center',
// //         marginTop: '40px'
// //       }}>
// //         <div>
// //           <Link 
// //             to="/termsofuse" 
// //             style={{ margin: '0 15px', color: '#0066cc', textDecoration: 'none' }}
// //           >
// //             Terms of Service
// //           </Link>
// //           <span style={{ color: '#999' }}>|</span>
// //           <Link 
// //             to="/privacypolicy" 
// //             style={{ margin: '0 15px', color: '#0066cc', textDecoration: 'none' }}
// //           >
// //             Privacy Policy
// //           </Link>
// //         </div>
// //         <p style={{ fontSize: '12px', color: '#666', marginTop: '10px', marginBottom: '0' }}>
// //           © 2025 On-Screen. All rights reserved.
// //         </p>
// //       </footer>
// //     </div>
// //   );
// // }

// // export default Login;



// // // import React, { useState } from 'react';
// // // import { toast } from 'react-toastify';
// // // import { useNavigate, Link } from 'react-router-dom';
// // // import axios from 'axios';

// // // function Login() {
// // //   const [credentials, setCredentials] = useState({ username: '', password: '' });
// // //   const [isLoading, setIsLoading] = useState(false);
// // //   const navigate = useNavigate();

// // //   const baseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:5000';

// // //   const handleInputChange = (e) => {
// // //     const { name, value } = e.target;
// // //     setCredentials({ ...credentials, [name]: value });
// // //   };
  
// // //   const login = async (e) => {
// // //     e.preventDefault();
// // //     setIsLoading(true);
    
// // //     try {
// // //       const response = await axios.post(`${baseUrl}/api/users/login`, credentials, { 
// // //         withCredentials: true 
// // //       });

// // //       if (response.status === 200 && response.data.success) {
// // //         const { user, sessionId } = response.data;
// // //         const { tenantid, id: ownerid, username } = user;

// // //         // ✅ Store session information in localStorage
// // //         localStorage.setItem('authToken', response.data.token || '');
// // //         localStorage.setItem('sessionId', sessionId); // ⭐ New: Store session ID
// // //         localStorage.setItem('tenantid', tenantid);
// // //         localStorage.setItem('ownerid', ownerid);
// // //         localStorage.setItem('username', username);
// // //         localStorage.setItem('role', user.role || 'operator');
        
// // //         // Store user object for easy access
// // //         try {
// // //           localStorage.setItem('me', JSON.stringify({ id: user.id, tenantId: user.tenantid }));
// // //           window.__ME__ = { id: user.id, tenantId: user.tenantid };
// // //         } catch {}
        
// // //         if (user) {
// // //           localStorage.setItem('user', JSON.stringify(user));
// // //         }

// // //         // toast.success('Login successful!');
// // //         navigate(`/${tenantid}/dashboard`);
// // //       } else {
// // //         toast.error(response.data.message || 'Unexpected error.');
// // //       }
// // //     } catch (error) {
// // //       // Handle specific error cases
// // //       if (error.response?.status === 401) {
// // //         toast.error('Invalid username or password.');
// // //       } else if (error.response?.status === 403) {
// // //         // ⭐ New: Handle user limit reached error
// // //         const errorData = error.response.data;
// // //         toast.error(
// // //           errorData.message || 'Maximum concurrent users reached. Please try again later.',
// // //           { autoClose: 8000 }
// // //         );
        
// // //         // Optionally show details
// // //         if (errorData.details) {
// // //           console.log('User limit details:', errorData.details);
// // //         }
// // //       } else {
// // //         console.error('Login error:', error);
// // //         toast.error('Failed to login. Please try again.');
// // //       }
// // //     } finally {
// // //       setIsLoading(false);
// // //     }
// // //   };

// // //   const handleOwner = () => navigate(`/ownerAdd`);

// // //   return (
// // //     <div className="col=md-4">
// // //       <div className="card">
// // //         <div className="card-body">
// // //           <h4 className="hdr hdr--primary hdr--lg">Login Here</h4>
// // //           <form onSubmit={login}>
// // //             <div className="form-group">
// // //               <label htmlFor="username">Username</label>
// // //               <input
// // //                 className="textInput"
// // //                 type="text"
// // //                 name="username"
// // //                 value={credentials.username}
// // //                 onChange={handleInputChange}
// // //                 placeholder="Enter your Username"
// // //                 required
// // //                 disabled={isLoading}
// // //               />
// // //             </div>
// // //             <div className="form-group">
// // //               <label htmlFor="password">Password</label>
// // //               <input
// // //                 className="textInput"
// // //                 type="password"
// // //                 name="password"
// // //                 autoComplete="current-password"
// // //                 value={credentials.password}
// // //                 onChange={handleInputChange}
// // //                 placeholder="Enter your Password"
// // //                 required
// // //                 disabled={isLoading}
// // //               />
// // //             </div>

// // //             {/* Forgot password link */}
// // //             <div className="mt-2">
// // //               <Link to="/reset-password" className="text-sm text-blue-600 hover:underline">
// // //                 Forgot password?
// // //               </Link>
// // //             </div>

// // //             <button 
// // //               className="btn btn-primary" 
// // //               type="submit"
// // //               disabled={isLoading}
// // //             >
// // //               {isLoading ? 'Logging in...' : 'Login'}
// // //             </button>
// // //             <button 
// // //               onClick={handleOwner} 
// // //               className="btn btn-primary" 
// // //               type="button"
// // //               disabled={isLoading}
// // //             >
// // //               Create Account
// // //             </button>
// // //           </form>
// // //         </div>
// // //       </div>
// // //     </div>
// // //   );
// // // }

// // // export default Login;


// // import React, { useState } from 'react';
// // import { toast } from 'react-toastify';
// // import { useNavigate, Link } from 'react-router-dom';
// // import axios from 'axios';

// // function Login() {
// //   const [credentials, setCredentials] = useState({ username: '', password: '' });
// //   const [isLoading, setIsLoading] = useState(false);
// //   const navigate = useNavigate();

// //   const baseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:5000';

// //   const handleInputChange = (e) => {
// //     const { name, value } = e.target;
// //     setCredentials({ ...credentials, [name]: value });
// //   };
  
// //   const login = async (e) => {
// //     e.preventDefault();
// //     setIsLoading(true);
    
// //     try {
// //       const response = await axios.post(`${baseUrl}/api/users/login`, credentials, { 
// //         withCredentials: true 
// //       });

// //       if (response.status === 200 && response.data.success) {
// //         const { user, sessionId, isReused } = response.data;
// //         const { tenantid, id: ownerid, username } = user;

// //         // ✅ Store session information in localStorage
// //         localStorage.setItem('authToken', response.data.token || '');
// //         localStorage.setItem('sessionId', sessionId); // ⭐ Store session ID
// //         localStorage.setItem('tenantid', tenantid);
// //         localStorage.setItem('ownerid', ownerid);
// //         localStorage.setItem('username', username);
// //         localStorage.setItem('role', user.role || 'operator');
        
// //         // Store user object for easy access
// //         try {
// //           localStorage.setItem('me', JSON.stringify({ id: user.id, tenantId: user.tenantid }));
// //           window.__ME__ = { id: user.id, tenantId: user.tenantid };
// //         } catch {}
        
// //         if (user) {
// //           localStorage.setItem('user', JSON.stringify(user));
// //         }

// //         // 📌 Show appropriate success message based on session reuse
// //         if (isReused) {
// //           console.log('♻️  Session reused - user was previously logged in');
// //           // Optional: Show a subtle message that they're continuing their previous session
// //           // toast.info('Welcome back! Continuing your previous session.', { autoClose: 2000 });
// //         } else {
// //           console.log('✨ New session created');
// //           // toast.success('Login successful!');
// //         }

// //         navigate(`/${tenantid}/dashboard`);
// //       } else {
// //         toast.error(response.data.message || 'Unexpected error.');
// //       }
// //     } catch (error) {
// //       // Handle specific error cases
// //       if (error.response?.status === 401) {
// //         toast.error('Invalid username or password.');
// //       } else if (error.response?.status === 403) {
// //         // ⭐ Handle user limit reached error
// //         const errorData = error.response.data;
// //         toast.error(
// //           errorData.message || 'Maximum concurrent users reached. Please try again later.',
// //           { autoClose: 8000 }
// //         );
        
// //         // Optionally show details in console
// //         if (errorData.details) {
// //           console.log('User limit details:', errorData.details);
// //         }
// //       } else {
// //         console.error('Login error:', error);
// //         toast.error('Failed to login. Please try again.');
// //       }
// //     } finally {
// //       setIsLoading(false);
// //     }
// //   };

// //   const handleOwner = () => navigate(`/ownerAdd`);

// //   return (
// //     <div className="col=md-4">
// //       <div className="card">
// //         <div className="card-body">
// //           <h4 className="hdr hdr--primary hdr--lg">Login Here</h4>
// //           <form onSubmit={login}>
// //             <div className="form-group">
// //               <label htmlFor="username">Username</label>
// //               <input
// //                 className="textInput"
// //                 type="text"
// //                 name="username"
// //                 value={credentials.username}
// //                 onChange={handleInputChange}
// //                 placeholder="Enter your Username"
// //                 required
// //                 disabled={isLoading}
// //               />
// //             </div>
// //             <div className="form-group">
// //               <label htmlFor="password">Password</label>
// //               <input
// //                 className="textInput"
// //                 type="password"
// //                 name="password"
// //                 autoComplete="current-password"
// //                 value={credentials.password}
// //                 onChange={handleInputChange}
// //                 placeholder="Enter your Password"
// //                 required
// //                 disabled={isLoading}
// //               />
// //             </div>

// //             {/* Forgot password link */}
// //             <div className="mt-2">
// //               <Link to="/reset-password" className="text-sm text-blue-600 hover:underline">
// //                 Forgot password?
// //               </Link>
// //             </div>

// //             <button 
// //               className="btn btn-primary" 
// //               type="submit"
// //               disabled={isLoading}
// //             >
// //               {isLoading ? 'Logging in...' : 'Login'}
// //             </button>
// //             <button 
// //               onClick={handleOwner} 
// //               className="btn btn-primary" 
// //               type="button"
// //               disabled={isLoading}
// //             >
// //               Create Account
// //             </button>
// //           </form>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }

// // export default Login;


// import React, { useState } from 'react';
// import { toast } from 'react-toastify';
// import { useNavigate, Link } from 'react-router-dom';
// import axios from 'axios';

// function Login() {
//   const [credentials, setCredentials] = useState({ username: '', password: '' });
//   const [isLoading, setIsLoading] = useState(false);
//   const navigate = useNavigate();

//   const baseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:5000';

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setCredentials({ ...credentials, [name]: value });
//   };
  
//   const login = async (e) => {
//     e.preventDefault();
//     setIsLoading(true);
    
//     try {
//       const response = await axios.post(`${baseUrl}/api/users/login`, credentials, { 
//         withCredentials: true 
//       });

//       if (response.status === 200 && response.data.success) {
//         const { user, sessionId, isReused } = response.data;
//         const { tenantid, id: ownerid, username } = user;

//         // ✅ Store session information in localStorage
//         localStorage.setItem('authToken', response.data.token || '');
//         localStorage.setItem('sessionId', sessionId); // ⭐ Store session ID
//         localStorage.setItem('tenantid', tenantid);
//         localStorage.setItem('ownerid', ownerid);
//         localStorage.setItem('username', username);
//         localStorage.setItem('role', user.role || 'operator');
        
//         // Store user object for easy access
//         try {
//           localStorage.setItem('me', JSON.stringify({ id: user.id, tenantId: user.tenantid }));
//           window.__ME__ = { id: user.id, tenantId: user.tenantid };
//         } catch {}
        
//         if (user) {
//           localStorage.setItem('user', JSON.stringify(user));
//         }

//         // 📌 Show appropriate success message based on session reuse
//         if (isReused) {
//           console.log('♻️  Session reused - user was previously logged in');
//           // Optional: Show a subtle message that they're continuing their previous session
//           // toast.info('Welcome back! Continuing your previous session.', { autoClose: 2000 });
//         } else {
//           console.log('✨ New session created');
//           // toast.success('Login successful!');
//         }

//         navigate(`/${tenantid}/dashboard`);
//       } else {
//         toast.error(response.data.message || 'Unexpected error.');
//       }
//     } catch (error) {
//       // Handle specific error cases
//       if (error.response?.status === 401) {
//         toast.error('Invalid username or password.');
//       } else if (error.response?.status === 403) {
//         // ⭐ Handle user limit reached error
//         const errorData = error.response.data;
//         toast.error(
//           errorData.message || 'Maximum concurrent users reached. Please try again later.',
//           { autoClose: 8000 }
//         );
        
//         // Optionally show details in console
//         if (errorData.details) {
//           console.log('User limit details:', errorData.details);
//         }
//       } else {
//         console.error('Login error:', error);
//         toast.error('Failed to login. Please try again.');
//       }
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleOwner = () => navigate(`/ownerAdd`);

//   return (
//     <div style={{
//       display: 'flex',
//       justifyContent: 'center',
//       alignItems: 'center',
//       minHeight: '100vh',
//       padding: '20px',
//       boxSizing: 'border-box'
//     }}>
//       <div style={{ width: '100%', maxWidth: '450px' }}>
//         <div className="card">
//           <div className="card-body">
//             <h4 className="hdr hdr--primary hdr--lg">Login Here</h4>
//             <form onSubmit={login}>
//               <div className="form-group">
//                 <label htmlFor="username">Username</label>
//                 <input
//                   className="textInput"
//                   type="text"
//                   name="username"
//                   value={credentials.username}
//                   onChange={handleInputChange}
//                   placeholder="Enter your Username"
//                   required
//                   disabled={isLoading}
//                 />
//               </div>
//               <div className="form-group">
//                 <label htmlFor="password">Password</label>
//                 <input
//                   className="textInput"
//                   type="password"
//                   name="password"
//                   autoComplete="current-password"
//                   value={credentials.password}
//                   onChange={handleInputChange}
//                   placeholder="Enter your Password"
//                   required
//                   disabled={isLoading}
//                 />
//               </div>

//               {/* Forgot password link */}
//               <div className="mt-2">
//                 <Link to="/reset-password" className="text-sm text-blue-600 hover:underline">
//                   Forgot password?
//                 </Link>
//               </div>

//               <button 
//                 className="btn btn-primary" 
//                 type="submit"
//                 disabled={isLoading}
//               >
//                 {isLoading ? 'Logging in...' : 'Login'}
//               </button>
//               <button 
//                 onClick={handleOwner} 
//                 className="btn btn-primary" 
//                 type="button"
//                 disabled={isLoading}
//               >
//                 Create Account
//               </button>
//             </form>
//           </div>
//         </div>

//         {/* Footer with Terms of Service and Privacy Policy links */}
//         <footer style={{
//           borderTop: '1px solid #e0e0e0',
//           padding: '20px',
//           textAlign: 'center',
//           marginTop: '40px'
//         }}>
//           <div>
//             <Link 
//               to="/termsofuse" 
//               style={{ margin: '0 15px', color: '#0066cc', textDecoration: 'none' }}
//             >
//               Terms of Service
//             </Link>
//             <span style={{ color: '#999' }}>|</span>
//             <Link 
//               to="/privacypolicy" 
//               style={{ margin: '0 15px', color: '#0066cc', textDecoration: 'none' }}
//             >
//               Privacy Policy
//             </Link>
//           </div>
//           <p style={{ fontSize: '12px', color: '#666', marginTop: '10px', marginBottom: '0' }}>
//             © 2025 On-Screen. All rights reserved.
//           </p>
//         </footer>
//       </div>
//     </div>
//   );
// }

// export default Login;


// import React, { useState } from 'react';
// import { toast } from 'react-toastify';
// import { useNavigate, Link } from 'react-router-dom';
// import axios from 'axios';

// function Login() {
//   const [credentials, setCredentials] = useState({ username: '', password: '' });
//   const [isLoading, setIsLoading] = useState(false);
//   const navigate = useNavigate();

//   const baseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:5000';

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setCredentials({ ...credentials, [name]: value });
//   };
  
//   const login = async (e) => {
//     e.preventDefault();
//     setIsLoading(true);
    
//     try {
//       const response = await axios.post(`${baseUrl}/api/users/login`, credentials, { 
//         withCredentials: true 
//       });

//       if (response.status === 200 && response.data.success) {
//         const { user, sessionId, isReused } = response.data;
//         const { tenantid, id: ownerid, username } = user;

//         // ✅ Store session information in localStorage
//         localStorage.setItem('authToken', response.data.token || '');
//         localStorage.setItem('sessionId', sessionId); // ⭐ Store session ID
//         localStorage.setItem('tenantid', tenantid);
//         localStorage.setItem('ownerid', ownerid);
//         localStorage.setItem('username', username);
//         localStorage.setItem('role', user.role || 'operator');
        
//         // Store user object for easy access
//         try {
//           localStorage.setItem('me', JSON.stringify({ id: user.id, tenantId: user.tenantid }));
//           window.__ME__ = { id: user.id, tenantId: user.tenantid };
//         } catch {}
        
//         if (user) {
//           localStorage.setItem('user', JSON.stringify(user));
//         }

//         // 📌 Show appropriate success message based on session reuse
//         if (isReused) {
//           console.log('♻️  Session reused - user was previously logged in');
//           // Optional: Show a subtle message that they're continuing their previous session
//           // toast.info('Welcome back! Continuing your previous session.', { autoClose: 2000 });
//         } else {
//           console.log('✨ New session created');
//           // toast.success('Login successful!');
//         }

//         navigate(`/${tenantid}/dashboard`);
//       } else {
//         toast.error(response.data.message || 'Unexpected error.');
//       }
//     } catch (error) {
//       // Handle specific error cases
//       if (error.response?.status === 401) {
//         toast.error('Invalid username or password.');
//       } else if (error.response?.status === 403) {
//         // ⭐ Handle user limit reached error
//         const errorData = error.response.data;
//         toast.error(
//           errorData.message || 'Maximum concurrent users reached. Please try again later.',
//           { autoClose: 8000 }
//         );
        
//         // Optionally show details in console
//         if (errorData.details) {
//           console.log('User limit details:', errorData.details);
//         }
//       } else {
//         console.error('Login error:', error);
//         toast.error('Failed to login. Please try again.');
//       }
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleOwner = () => navigate(`/ownerAdd`);

//   return (
//     <div className="col=md-4">
//       <div className="card">
//         <div className="card-body">
//           <h4 className="hdr hdr--primary hdr--lg">Login Here</h4>
//           <form onSubmit={login}>
//             <div className="form-group">
//               <label htmlFor="username">Username</label>
//               <input
//                 className="textInput"
//                 type="text"
//                 name="username"
//                 value={credentials.username}
//                 onChange={handleInputChange}
//                 placeholder="Enter your Username"
//                 required
//                 disabled={isLoading}
//               />
//             </div>
//             <div className="form-group">
//               <label htmlFor="password">Password</label>
//               <input
//                 className="textInput"
//                 type="password"
//                 name="password"
//                 autoComplete="current-password"
//                 value={credentials.password}
//                 onChange={handleInputChange}
//                 placeholder="Enter your Password"
//                 required
//                 disabled={isLoading}
//               />
//             </div>

//             {/* Forgot password link */}
//             <div className="mt-2">
//               <Link to="/reset-password" className="text-sm text-blue-600 hover:underline">
//                 Forgot password?
//               </Link>
//             </div>

//             <button 
//               className="btn btn-primary" 
//               type="submit"
//               disabled={isLoading}
//             >
//               {isLoading ? 'Logging in...' : 'Login'}
//             </button>
//             <button 
//               onClick={handleOwner} 
//               className="btn btn-primary" 
//               type="button"
//               disabled={isLoading}
//             >
//               Create Account
//             </button>
//           </form>
//         </div>
//       </div>

//       {/* Footer with Terms of Service and Privacy Policy links */}
//       <footer style={{
//         borderTop: '1px solid #e0e0e0',
//         padding: '20px',
//         textAlign: 'center',
//         marginTop: '40px'
//       }}>
//         <div>
//           <Link 
//             to="/termsofuse" 
//             style={{ margin: '0 15px', color: '#0066cc', textDecoration: 'none' }}
//           >
//             Terms of Service
//           </Link>
//           <span style={{ color: '#999' }}>|</span>
//           <Link 
//             to="/privacypolicy" 
//             style={{ margin: '0 15px', color: '#0066cc', textDecoration: 'none' }}
//           >
//             Privacy Policy
//           </Link>
//         </div>
//         <p style={{ fontSize: '12px', color: '#666', marginTop: '10px', marginBottom: '0' }}>
//           © 2025 On-Screen. All rights reserved.
//         </p>
//       </footer>
//     </div>
//   );
// }

// export default Login;



// // import React, { useState } from 'react';
// // import { toast } from 'react-toastify';
// // import { useNavigate, Link } from 'react-router-dom';
// // import axios from 'axios';

// // function Login() {
// //   const [credentials, setCredentials] = useState({ username: '', password: '' });
// //   const [isLoading, setIsLoading] = useState(false);
// //   const navigate = useNavigate();

// //   const baseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:5000';

// //   const handleInputChange = (e) => {
// //     const { name, value } = e.target;
// //     setCredentials({ ...credentials, [name]: value });
// //   };
  
// //   const login = async (e) => {
// //     e.preventDefault();
// //     setIsLoading(true);
    
// //     try {
// //       const response = await axios.post(`${baseUrl}/api/users/login`, credentials, { 
// //         withCredentials: true 
// //       });

// //       if (response.status === 200 && response.data.success) {
// //         const { user, sessionId } = response.data;
// //         const { tenantid, id: ownerid, username } = user;

// //         // ✅ Store session information in localStorage
// //         localStorage.setItem('authToken', response.data.token || '');
// //         localStorage.setItem('sessionId', sessionId); // ⭐ New: Store session ID
// //         localStorage.setItem('tenantid', tenantid);
// //         localStorage.setItem('ownerid', ownerid);
// //         localStorage.setItem('username', username);
// //         localStorage.setItem('role', user.role || 'operator');
        
// //         // Store user object for easy access
// //         try {
// //           localStorage.setItem('me', JSON.stringify({ id: user.id, tenantId: user.tenantid }));
// //           window.__ME__ = { id: user.id, tenantId: user.tenantid };
// //         } catch {}
        
// //         if (user) {
// //           localStorage.setItem('user', JSON.stringify(user));
// //         }

// //         // toast.success('Login successful!');
// //         navigate(`/${tenantid}/dashboard`);
// //       } else {
// //         toast.error(response.data.message || 'Unexpected error.');
// //       }
// //     } catch (error) {
// //       // Handle specific error cases
// //       if (error.response?.status === 401) {
// //         toast.error('Invalid username or password.');
// //       } else if (error.response?.status === 403) {
// //         // ⭐ New: Handle user limit reached error
// //         const errorData = error.response.data;
// //         toast.error(
// //           errorData.message || 'Maximum concurrent users reached. Please try again later.',
// //           { autoClose: 8000 }
// //         );
        
// //         // Optionally show details
// //         if (errorData.details) {
// //           console.log('User limit details:', errorData.details);
// //         }
// //       } else {
// //         console.error('Login error:', error);
// //         toast.error('Failed to login. Please try again.');
// //       }
// //     } finally {
// //       setIsLoading(false);
// //     }
// //   };

// //   const handleOwner = () => navigate(`/ownerAdd`);

// //   return (
// //     <div className="col=md-4">
// //       <div className="card">
// //         <div className="card-body">
// //           <h4 className="hdr hdr--primary hdr--lg">Login Here</h4>
// //           <form onSubmit={login}>
// //             <div className="form-group">
// //               <label htmlFor="username">Username</label>
// //               <input
// //                 className="textInput"
// //                 type="text"
// //                 name="username"
// //                 value={credentials.username}
// //                 onChange={handleInputChange}
// //                 placeholder="Enter your Username"
// //                 required
// //                 disabled={isLoading}
// //               />
// //             </div>
// //             <div className="form-group">
// //               <label htmlFor="password">Password</label>
// //               <input
// //                 className="textInput"
// //                 type="password"
// //                 name="password"
// //                 autoComplete="current-password"
// //                 value={credentials.password}
// //                 onChange={handleInputChange}
// //                 placeholder="Enter your Password"
// //                 required
// //                 disabled={isLoading}
// //               />
// //             </div>

// //             {/* Forgot password link */}
// //             <div className="mt-2">
// //               <Link to="/reset-password" className="text-sm text-blue-600 hover:underline">
// //                 Forgot password?
// //               </Link>
// //             </div>

// //             <button 
// //               className="btn btn-primary" 
// //               type="submit"
// //               disabled={isLoading}
// //             >
// //               {isLoading ? 'Logging in...' : 'Login'}
// //             </button>
// //             <button 
// //               onClick={handleOwner} 
// //               className="btn btn-primary" 
// //               type="button"
// //               disabled={isLoading}
// //             >
// //               Create Account
// //             </button>
// //           </form>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }

// // export default Login;


// import React, { useState } from 'react';
// import { toast } from 'react-toastify';
// import { useNavigate, Link } from 'react-router-dom';
// import axios from 'axios';

// function Login() {
//   const [credentials, setCredentials] = useState({ username: '', password: '' });
//   const [isLoading, setIsLoading] = useState(false);
//   const navigate = useNavigate();

//   const baseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:5000';

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setCredentials({ ...credentials, [name]: value });
//   };
  
//   const login = async (e) => {
//     e.preventDefault();
//     setIsLoading(true);
    
//     try {
//       const response = await axios.post(`${baseUrl}/api/users/login`, credentials, { 
//         withCredentials: true 
//       });

//       if (response.status === 200 && response.data.success) {
//         const { user, sessionId, isReused } = response.data;
//         const { tenantid, id: ownerid, username } = user;

//         // ✅ Store session information in localStorage
//         localStorage.setItem('authToken', response.data.token || '');
//         localStorage.setItem('sessionId', sessionId); // ⭐ Store session ID
//         localStorage.setItem('tenantid', tenantid);
//         localStorage.setItem('ownerid', ownerid);
//         localStorage.setItem('username', username);
//         localStorage.setItem('role', user.role || 'operator');
        
//         // Store user object for easy access
//         try {
//           localStorage.setItem('me', JSON.stringify({ id: user.id, tenantId: user.tenantid }));
//           window.__ME__ = { id: user.id, tenantId: user.tenantid };
//         } catch {}
        
//         if (user) {
//           localStorage.setItem('user', JSON.stringify(user));
//         }

//         // 📌 Show appropriate success message based on session reuse
//         if (isReused) {
//           console.log('♻️  Session reused - user was previously logged in');
//           // Optional: Show a subtle message that they're continuing their previous session
//           // toast.info('Welcome back! Continuing your previous session.', { autoClose: 2000 });
//         } else {
//           console.log('✨ New session created');
//           // toast.success('Login successful!');
//         }

//         navigate(`/${tenantid}/dashboard`);
//       } else {
//         toast.error(response.data.message || 'Unexpected error.');
//       }
//     } catch (error) {
//       // Handle specific error cases
//       if (error.response?.status === 401) {
//         toast.error('Invalid username or password.');
//       } else if (error.response?.status === 403) {
//         // ⭐ Handle user limit reached error
//         const errorData = error.response.data;
//         toast.error(
//           errorData.message || 'Maximum concurrent users reached. Please try again later.',
//           { autoClose: 8000 }
//         );
        
//         // Optionally show details in console
//         if (errorData.details) {
//           console.log('User limit details:', errorData.details);
//         }
//       } else {
//         console.error('Login error:', error);
//         toast.error('Failed to login. Please try again.');
//       }
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleOwner = () => navigate(`/ownerAdd`);

//   return (
//     <div className="col=md-4">
//       <div className="card">
//         <div className="card-body">
//           <h4 className="hdr hdr--primary hdr--lg">Login Here</h4>
//           <form onSubmit={login}>
//             <div className="form-group">
//               <label htmlFor="username">Username</label>
//               <input
//                 className="textInput"
//                 type="text"
//                 name="username"
//                 value={credentials.username}
//                 onChange={handleInputChange}
//                 placeholder="Enter your Username"
//                 required
//                 disabled={isLoading}
//               />
//             </div>
//             <div className="form-group">
//               <label htmlFor="password">Password</label>
//               <input
//                 className="textInput"
//                 type="password"
//                 name="password"
//                 autoComplete="current-password"
//                 value={credentials.password}
//                 onChange={handleInputChange}
//                 placeholder="Enter your Password"
//                 required
//                 disabled={isLoading}
//               />
//             </div>

//             {/* Forgot password link */}
//             <div className="mt-2">
//               <Link to="/reset-password" className="text-sm text-blue-600 hover:underline">
//                 Forgot password?
//               </Link>
//             </div>

//             <button 
//               className="btn btn-primary" 
//               type="submit"
//               disabled={isLoading}
//             >
//               {isLoading ? 'Logging in...' : 'Login'}
//             </button>
//             <button 
//               onClick={handleOwner} 
//               className="btn btn-primary" 
//               type="button"
//               disabled={isLoading}
//             >
//               Create Account
//             </button>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Login;


import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { touchActivity } from '../utils/sessionUtils';
import TenantSelectionModal from './shared/TenantSelectionModal';
import PasswordInput from './shared/PasswordInput';

function Login() {
  const { t } = useTranslation();
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Multi-tenant selection state
  const [tenantSelection, setTenantSelection] = useState(null); // { tenants, loginType }

  const baseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:5000';

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCredentials({ ...credentials, [name]: value });
  };

  /** Stores session data in localStorage and navigates to dashboard */
  const completeLogin = (data) => {
    const { user, sessionId, isReused } = data;
    const { tenantid, id: ownerid, username } = user;

    localStorage.setItem('authToken', data.token || '');
    localStorage.setItem('sessionId', sessionId);
    localStorage.setItem('tenantid', tenantid);
    localStorage.setItem('tenantId', String(tenantid));
    localStorage.setItem('ownerid', ownerid);
    localStorage.setItem('userId', String(ownerid));
    localStorage.setItem('username', username);
    localStorage.setItem('role', user.role || 'operator');

    try {
      localStorage.setItem('me', JSON.stringify({ id: user.id, tenantId: user.tenantid }));
      window.__ME__ = { id: user.id, tenantId: user.tenantid };
    } catch {}

    if (user) {
      localStorage.setItem('user', JSON.stringify(user));
    }

    if (isReused) {
      console.log('Session reused - user was previously logged in');
    } else {
      console.log('New session created');
    }

    touchActivity();

    const returnTo = searchParams.get('returnTo');
    if (returnTo && returnTo.startsWith('/')) {
      navigate(returnTo, { replace: true });
    } else {
      navigate(`/${tenantid}/dashboard`);
    }
  };

  const login = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await axios.post(`${baseUrl}/api/users/login`, credentials, {
        withCredentials: true
      });

      if (response.status === 200 && response.data.success) {
        // Check if backend is asking for tenant selection
        if (response.data.requiresTenantSelection) {
          setTenantSelection({
            tenants: response.data.tenants,
            loginType: response.data.loginType
          });
          setIsLoading(false);
          return;
        }

        // Single tenant - complete login directly
        completeLogin(response.data);
      } else {
        toast.error(response.data.message || t('common.unexpectedError'));
      }
    } catch (error) {
      if (error.response?.status === 401) {
        toast.error(t('auth.invalidCredentialsError'));
      } else if (error.response?.status === 403) {
        const errorData = error.response.data;
        toast.error(
          errorData.message || t('auth.maxConcurrentUsersError'),
          { autoClose: 8000 }
        );
        if (errorData.details) {
          console.log('User limit details:', errorData.details);
        }
      } else {
        console.error('Login error:', error);
        toast.error(t('auth.loginFailedError'));
      }
    } finally {
      setIsLoading(false);
    }
  };

  /** Called when user picks a tenant from the selection modal */
  const handleTenantSelect = async (tenantId) => {
    setIsLoading(true);
    try {
      const response = await axios.post(
        `${baseUrl}/api/users/select-tenant`,
        {
          username: credentials.username,
          password: credentials.password,
          tenantId,
          loginType: tenantSelection.loginType
        },
        { withCredentials: true }
      );

      if (response.data.success) {
        setTenantSelection(null);
        completeLogin(response.data);
      } else {
        toast.error(response.data.message || t('common.unexpectedError'));
      }
    } catch (error) {
      if (error.response?.status === 403) {
        toast.error(
          error.response.data?.message || t('auth.maxConcurrentUsersError'),
          { autoClose: 8000 }
        );
      } else {
        console.error('Tenant selection error:', error);
        toast.error(t('auth.loginFailedError'));
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleOwner = () => navigate(`/ownerAdd`);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      padding: '20px',
      boxSizing: 'border-box'
    }}>
      <div style={{ width: '100%', maxWidth: '450px' }}>
        <div className="card">
          <div className="card-body">
            <h4 className="hdr hdr--primary hdr--lg">{t('auth.loginTitle')}</h4>
            <form onSubmit={login}>
              <div className="form-group">
                <label htmlFor="username">{t('auth.usernameLabel')}</label>
                <input
                  className="textInput"
                  type="text"
                  name="username"
                  value={credentials.username}
                  onChange={handleInputChange}
                  placeholder={t('auth.usernamePlaceholder')}
                  required
                  disabled={isLoading}
                />
              </div>
              <div className="form-group">
                <label htmlFor="password">{t('auth.passwordLabel')}</label>
                <PasswordInput
                  className="textInput"
                  name="password"
                  autoComplete="current-password"
                  value={credentials.password}
                  onChange={handleInputChange}
                  placeholder={t('auth.passwordPlaceholder')}
                  required
                  disabled={isLoading}
                />
              </div>

              {/* Forgot password link */}
              <div className="mt-2">
                <Link to="/reset-password" className="text-sm text-blue-600 hover:underline">
                  {t('auth.forgotPasswordLink')}
                </Link>
              </div>

              <button
                className="btn btn-primary"
                type="submit"
                disabled={isLoading}
              >
                {isLoading ? t('auth.loggingInButton') : t('auth.loginButton')}
              </button>
              <button
                onClick={handleOwner}
                className="btn btn-primary"
                type="button"
                disabled={isLoading}
              >
                {t('auth.createAccountButton')}
              </button>
            </form>
          </div>
        </div>

        {/* Footer with Terms of Service and Privacy Policy links */}
        <footer style={{
          borderTop: '1px solid #e0e0e0',
          padding: '20px',
          textAlign: 'center',
          marginTop: '40px'
        }}>
          <div>
            <Link
              to="/termsofuse"
              style={{ margin: '0 15px', color: '#0066cc', textDecoration: 'none' }}
            >
              {t('common.termsOfServiceLink')}
            </Link>
            <span style={{ color: '#999' }}>|</span>
            <Link
              to="/privacypolicy"
              style={{ margin: '0 15px', color: '#0066cc', textDecoration: 'none' }}
            >
              {t('common.privacyPolicyLink')}
            </Link>
          </div>
          <p style={{ fontSize: '12px', color: '#666', marginTop: '10px', marginBottom: '0' }}>
            {t('common.copyrightText')}
          </p>
        </footer>
      </div>

      {/* Tenant selection modal - shown when user has multiple tenants */}
      {tenantSelection && (
        <TenantSelectionModal
          tenants={tenantSelection.tenants}
          onSelect={handleTenantSelect}
          onCancel={() => setTenantSelection(null)}
          isLoading={isLoading}
        />
      )}
    </div>
  );
}

export default Login;